import { render } from "./ProjectViewList.vue?vue&type=template&id=21b2d7aa&scoped=true"
import script from "./ProjectViewList.vue?vue&type=script&lang=js"
export * from "./ProjectViewList.vue?vue&type=script&lang=js"

import "./ProjectViewList.vue?vue&type=style&index=0&id=21b2d7aa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b2d7aa"]])

export default __exports__